import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f5291be")

_pushScopeId("data-v-4f5291be")
const _hoisted_1 = { class: "main" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", {
      "data-test": "statusAvailable",
      class: [
        'status',
        { 'status--available': _ctx.modelValueComputed === 'AVAILABLE' },
      ],
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValueComputed = 'AVAILABLE'))
    }, " Disponível ", 2),
    _createVNode("span", {
      "data-test": "statusReserved",
      class: [
        'status',
        { 'status--reserved': _ctx.modelValueComputed === 'RESERVED' },
      ],
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValueComputed = 'RESERVED'))
    }, "Reservado ", 2),
    _createVNode("span", {
      "data-test": "statusUnavailable",
      class: [
        'status',
        { 'status--unavailable': _ctx.modelValueComputed === 'UNAVAILABLE' },
      ],
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValueComputed = 'UNAVAILABLE'))
    }, "Indisponível ", 2)
  ]))
})